module.exports = "<div class=form-field> <div ng-if=!$ctrl.hideLabel ng-class=[$ctrl.labelClass] class=form-field-label> {{ $ctrl.label }} </div> <div ng-clas=[$ctrl.inputClass] class=form-field-input> <div ng-repeat=\"option in $ctrl.options\" class=radio> <label> <input ng-checked=option.isSelected ng-click=\"$ctrl.onSelect({option: option})\" type=radio> <span> {{ option.label }} </span> </label> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/form-fields/radio-field/radio-field.html
// module id = 345
// module chunks = 0